import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { format } from 'date-fns';

export const SessionFeedbackDialog = ({ open, onOpenChange, session, form, setForm, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg">
      <DialogHeader>
        <DialogTitle>Session Feedback</DialogTitle>
        <DialogDescription>
          {session?.title} - {session?.session_date ? format(new Date(session.session_date), 'MMM d, yyyy') : ''}
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>
              MTM Trainer Rating
              <span className="text-muted-foreground font-normal ml-1 text-xs">(Optional, out of 5)</span>
            </Label>
            <div className="relative">
              <Input
                type="number"
                min="0"
                max="5"
                step="0.1"
                value={form.mtm_trainer_rating}
                onChange={(e) => setForm({ ...form, mtm_trainer_rating: e.target.value })}
                placeholder="e.g. 4.2"
                data-testid="mtm-trainer-rating-input"
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground pointer-events-none">/5</span>
            </div>
          </div>
          <div className="space-y-2">
            <Label>
              MTM Course Rating
              <span className="text-muted-foreground font-normal ml-1 text-xs">(Optional, out of 5)</span>
            </Label>
            <div className="relative">
              <Input
                type="number"
                min="0"
                max="5"
                step="0.1"
                value={form.mtm_course_rating}
                onChange={(e) => setForm({ ...form, mtm_course_rating: e.target.value })}
                placeholder="e.g. 4.5"
                data-testid="mtm-course-rating-input"
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground pointer-events-none">/5</span>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <Label>Verbatims / Comments <span className="text-muted-foreground font-normal text-xs">(Optional)</span></Label>
          <Textarea
            value={form.verbatims}
            onChange={(e) => setForm({ ...form, verbatims: e.target.value })}
            placeholder="Participant verbatims or key comments..."
            rows={3}
            data-testid="verbatims-input"
          />
        </div>

        <div className="space-y-2">
          <Label>What went well? <span className="text-muted-foreground font-normal text-xs">(Optional)</span></Label>
          <Textarea
            value={form.highlights}
            onChange={(e) => setForm({ ...form, highlights: e.target.value })}
            placeholder="Key highlights and successes..."
            rows={2}
          />
        </div>

        <div className="space-y-2">
          <Label>Areas for Improvement <span className="text-muted-foreground font-normal text-xs">(Optional)</span></Label>
          <Textarea
            value={form.improvements}
            onChange={(e) => setForm({ ...form, improvements: e.target.value })}
            placeholder="What could be improved..."
            rows={2}
          />
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} className="bg-lime text-lime-foreground hover:bg-lime/90" data-testid="save-session-feedback-btn">
            Save Feedback
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default SessionFeedbackDialog;
